enum ExportType {
    ANSWERS = 'ANSWERS',
    HOT_ALERTS = 'HOT_ALERTS',
    CHAT = 'CHAT',
}

export default ExportType;
